
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'


import HttpUtil from '../../util/HttpUtil'
export default{
name:'addCommondity',
components:{
XHeader,XInput,Toast,XSwitch
},
data(){
return{
uploadUrl:'/testUploadFile',
images:[],
goodscode:'',
goodsname:'',
spec:'',
price:0.00,
filename:'',
show1: false,
text1: 'Processing',
unit:'只',
title:'新增商品',
id:0,
putaway:false
}
},
mounted(){
console.log(this.$route);
if(this.$route.query.id){
this.title = '修改商品';
this.goodscode = this.$route.query.goodscode;
this.goodsname = this.$route.query.goodsname;
this.spec = this.$route.query.spec;
this.price = this.$route.query.price;
this.unit = this.$route.query.unit;
this.images.push({url:this.$route.query.src});
this.id = this.$route.query.id;
this.putaway = this.$route.query.putaway;
}
},
methods:{
showLoading(){
this.$vux.loading.show({
text: '正在保存'
})
},
hideLoading(){
this.$vux.loading.hide();
},
save(){


if(!this.goodscode){
this.$vux.toast.show({
text: '商品编码不能为空',
type: 'warn'
})

return;
}
if(!this.goodsname){
this.$vux.toast.show({
text: '商品名称不能为空',
type: 'warn'
})

return;
}

var src = '';
if(this.images.length > 0){
let index = this.images[0].url.lastIndexOf('\/');
src=this.images[0].url.substring(index+1);
}
this.showLoading();
var _this = this;
var url = 'goods/saveGoods';
if(this.$route.query.id){
url = 'goods/updateGoods';
}

console.log(this.$store.state.vux.snsUserInfo.username);
HttpUtil.post(url,
{
goodscode:this.goodscode,
goodsname:this.goodsname,
spec:this.spec,
price:this.price,
src:src,
unit:this.unit,
id:this.id,
username:this.$store.state.vux.snsUserInfo.username,
putaway:this.putaway
},function(data){
if(data.result =="success"){
_this.$vux.toast.show({
text: '保存成功',
type: 'success'
})
_this.$router.push({path:'/'});
}
else if (data.result == "exists"){
_this.$vux.toast.show({
text: '该物品编码已存在',
type: 'warn'
})
}
_this.hideLoading();
})

},

}
}



// WEBPACK FOOTER //
// ./src/components/page1/AddCommondity.vue